export const getAccountType = (accountTypes, accountTypeId) => {
  return accountTypes?.find(acc => acc._id === accountTypeId);
};